
    // @ts-nocheck
    import { __internal_buildRpcClient } from "@blitzjs/rpc";
    export default __internal_buildRpcClient({
      resolverName: "submitPrivateSchoolBooking",
      resolverType: "mutation",
      routePath: "/submitPrivateSchoolBooking",
      httpMethod: "POST",
    });
  